
import { useEffect, useState } from "react"
import { Link, useParams } from "react-router-dom"
import { Flip, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";
import { Button, TextField } from "@mui/material";
import apiSafibc from "../../axios/axios";
import { Table, Pagination } from 'react-bootstrap';
import PieChartSa from "./PieChartSa";
import BarChartSa from "./BarChartSa";

const RevisarPagos = () => {

    const [sesion, setSesion] = useState(false)
    const [login, setLogin] = useState(true)

    const [spSeguimientoAbonos, setSpSeguimientoAbonos] = useState(false)
    const [codigo, setCodigo] = useState('')
    const [cel, setCel] = useState('')
    const [abonos, setAbonos] = useState([])
    const [ahorrosPagados, setAhorrosPagados] = useState(0)
    const [pagosContrato, setPagosContrato] = useState([])
    

    const { ahorrador } = useParams();

    const [paginaActual, setPaginaActual] = useState(1);
    const registrosPorPagina = 5;

    const [registrosPagination, setRegistrosPagination] = useState([])
    const indiceUltimoRegistro = paginaActual * registrosPorPagina;
    const indicePrimerRegistro = indiceUltimoRegistro - registrosPorPagina;


    const loginPagos = () => {

        const login_seguimiento = async () => {

            const auth = {
                codigo, cel, ahorrador
            }

            try {
                setSpSeguimientoAbonos(true)

                const ahorros = await apiSafibc.post('/login-seguimiento-abonos', auth, {
                    headers: {
                        'XP1-K3Y': `S4f1Vc`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setSpSeguimientoAbonos(false)
                setLogin(false)

                const meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC']

                //formateando fechas
                if (ahorros.data.length > 0) {
                    ahorros.data.forEach(pago => {
                        //console.log(pago.fecha_pago)
                        const p = pago.fecha_pago.split('T')
                        //let d = new Date(`${pago.fecha_pago}`)
                        let d = new Date(`${p[0].split('-')[0]}-${p[0].split('-')[1]}-${p[0].split('-')[2]} 08:00:00`)

                        pago.fecha_pago_th = `${d.getDate().toString().padStart('2', '0')}-${meses[d.getMonth()]}-${d.getFullYear()}`
                    })
                }

                const pagados = ahorros.data.filter(p => p.ahorro_pagado === true).length

                setAhorrosPagados(pagados)
                setPagosContrato(ahorros.data)

                setAbonos(ahorros.data)
                setSesion(true)


                setRegistrosPagination(ahorros.data.slice(indicePrimerRegistro, indiceUltimoRegistro))
                //const registrosActuales = ahorros.data.slice(indicePrimerRegistro, indiceUltimoRegistro);


            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al guardar ahorrador, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
                setSpSeguimientoAbonos(false)
            }



        }

        login_seguimiento()


    }

    const dineroFormatter = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN' // Puedes cambiar esto según la moneda que desees
    });


    return (
        <>

            {login &&
                <div className="bg-sa d-flex align-items-center ">
                    <div className=" container animation">
                        <div className="row d-flex justify-content-center">
                            <div className="col-md-8">
                                <div className="card-transparent border-0">
                                    <div className="card-body">
                                        <div className="row ">
                                            <div className="col-md-12 d-flex justify-content-center mb-3">
                                                <img src="/img/logosafibc.png" alt="logo" className="maxw" width={'50%'} />
                                            </div>
                                            <div className="col-md-12">
                                                <p className="text-center fw-bold">
                                                    Ingrese el codigo de acceso enviado <br /> por mensaje y los ultimos 4 digitos <br /> del celular registrado en el contrato.
                                                </p>
                                            </div>
                                            <div className="col-md-12 d-flex justify-content-center mb-2">
                                                <TextField value={codigo} onChange={(e) => setCodigo(e.target.value)} variant="standard" label="Codigo de Acceso" inputProps={{ maxLength: 8 }} style={{ 'width': '50%' }} />
                                            </div>
                                            <div className="col-md-12 d-flex justify-content-center mb-3">
                                                <TextField value={cel} onChange={(e) => setCel(e.target.value)} variant="standard" label="Celular" inputProps={{ maxLength: 4 }} style={{ 'width': '50%' }} />
                                            </div>
                                            <div className="col-md-12 d-flex justify-content-center mb-2">
                                                <Button disabled={spSeguimientoAbonos} variant="contained" style={{ 'width': '50%' }} onClick={loginPagos}>
                                                    Aceptar
                                                    {spSeguimientoAbonos && <div className="spinner-border spinner-border-sm" role="status" id='spisLoad'>
                                                        <span className="sr-only"></span>
                                                    </div>}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            }



            {sesion &&
                <>
                    <div className="container-fluid">
                        <div className="row">
                            <nav className="navbar nav-header1" >
                                <div className="row">
                                    <div className="col-md-3 ms-5 py-2">
                                        <Link to={'/'}>
                                            <img src="/img/logosafibc.png" width={'650'} alt="" className="maxw" />
                                        </Link>
                                    </div>
                                </div>
                            </nav>
                            <nav className="navbar navbar-expand-md shadow nav-header2 pt-3">
                                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                    <span className="navbar-toggler-icon"></span>
                                </button>

                            </nav>
                        </div>
                    </div>
                    <div className="container-fluid py-5 bg-linesimage" style={{ 'backgroundColor': '#f2f3f8' }}>
                        <div className="row d-flex justify-content-center animation" >
                            <div className="col-md-10 mb-3">
                                <div className="card  shadow border-0">
                                    <div className="card-header custom-card-bg"></div>
                                    <div className="card-body">
                                        <hr />
                                        <h2>Calendario de Pagos</h2>
                                        <div className="table-responsive">
                                            <div className="mb-3">
                                                <label className="fw-bold d-block">Ahorros:</label>
                                                <div className="d-flex justify-content-between mb-1">
                                                    <span className="fs-4">{ahorrosPagados} pagados</span>
                                                    <span className="fs-4">{pagosContrato.length} en total</span>
                                                </div>
                                                <div className="progress">
                                                    <div
                                                        className="progress-bar"
                                                        role="progressbar"
                                                        style={{ width: `${(ahorrosPagados / pagosContrato.length) * 100}%` }}
                                                        aria-valuenow={ahorrosPagados}
                                                        aria-valuemin="0"
                                                        aria-valuemax={pagosContrato.length}
                                                    >
                                                        {((ahorrosPagados / pagosContrato.length) * 100).toFixed(0)}%
                                                    </div>
                                                </div>
                                            </div>
                                            {pagosContrato &&
                                                <div className='table-responsive'>
                                                    <table className='table'>
                                                        <thead >
                                                            <tr>
                                                                {pagosContrato.map(fp => (
                                                                    <th key={fp.fecha_pago} scope="col" className='text-center' style={{ 'whiteSpace': 'nowrap' }}>{fp.fecha_pago_th}</th>
                                                                ))}

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                {pagosContrato.map(pago => (
                                                                    <td
                                                                        key={pago.id_registro}
                                                
                                                                        className={pago.ahorro_pagado ? 'bg-success text-light' : 'bg-danger pagos-hover text-light'}
                                                                    >
                                                                        {dineroFormatter.format(pago.cantidad)}
                                                                    </td>
                                                                ))}

                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                        </div>
                                        <hr />


                                    </div>
                                    <div className="card-footer custom-card-bg"></div>
                                </div>
                            </div>
                            <div className="col-md-5 mb-3">
                                <div className="card shadow border-0" >
                                    <div className="card-header custom-card-bg"></div>
                                    <div className="card-body">
                                        <hr />
                                        <PieChartSa abonos={abonos} />
                                        <hr />
                                    </div>
                                    <div className="card-footer custom-card-bg"></div>
                                </div>

                            </div>
                            <div className="col-md-5 mb-3">
                                <div className="card shadow border-0">
                                    <div className="card-header custom-card-bg"></div>
                                    <div className="card-body">
                                        <hr />
                                        <BarChartSa abonos={abonos} />
                                        <hr />
                                    </div>
                                    <div className="card-footer custom-card-bg"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </>
            }

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </>
    )

}

export default RevisarPagos